import React, { Component } from "react"
import { Label } from "@atlaskit/field-base"
import Moment from "moment-timezone"

const SMALL_FONT_SIZE = "18px"
const MEDIUM_FONT_SIZE = "22px"
const LARGE_FONT_SIZE = "30px"

class ReportResult extends Component {
  render() {
    console.log("render ReportResult")
    const {
      from,
      to,
      // available_vacation_days,
      // available_vacation_days_new,
      // week_days_count,
      // holiday_days_count,
      vacation_days_count,
      special_vacation_days_count,
      sickness_days_count,
      // should_work_days,
      // weekly_work_time_duration,
      // should_work_duration,
      work_time_duration,
      // current_extra_time_duration,
      // previous_extra_time_duration,
      paid_extra_time_duration,
      // total_extra_time_duration
      homeOfficeDays
    } = this.props

    var used_vacation_days =
      parseFloat(vacation_days_count) + parseFloat(special_vacation_days_count)
    // var remaining_vacation_days =
    //   parseFloat(available_vacation_days) +
    //   parseFloat(available_vacation_days_new) -
    //   parseFloat(vacation_days_count)

    return (
      <div
        style={{
          margin: "40px",
          textAlign: "center",
          pageBreakInside: "avoid"
        }}
      >
        <div style={{ height: "20px" }} />
        <table
          style={{
            width: "100%",
            marginBottom: "3em"
          }}
        >
          <tbody>
            <tr>
              <td colSpan={7} style={{ paddingBottom: "3em" }}>
                <div style={{ fontWeight: "bold", fontSize: "2em" }}>{this.props.fullname}</div>
                Zeiterfassungsreport<br/>
                <small>{Moment(from).format("MMMM YYYY")}</small>
              </td>
            </tr>
            <tr>
              <td />
              <td />
              <td>
                <Label label="Von" />
                <b style={{ fontSize: MEDIUM_FONT_SIZE }}>
                  {Moment(from).format("DD.MM.YYYY")}
                </b>
              </td>
              <td />
              <td>
                <Label label="Bis" />
                <b style={{ fontSize: MEDIUM_FONT_SIZE }}>
                  {Moment(to).format("DD.MM.YYYY")}
                </b>
              </td>
              <td />
              <td />
            </tr>
          </tbody>
        </table>

        <table style={{
          width: "100%",
          marginBottom: "3em"
        }}>
          <tbody>
            <tr>
              <td style={{ paddingBottom: "1.5em" }}>
                <Label label="Normale Urlaubstage" />
                <b style={{ fontSize: SMALL_FONT_SIZE }}>
                  {vacation_days_count}
                </b>
              </td>
              <td
                style={{
                  fontSize: LARGE_FONT_SIZE,
                  paddingTop: "40px",
                  paddingBottom: "1.5em"
                }}
              >
                +
              </td>
              <td style={{ paddingBottom: "1.5em" }}>
                <Label label="Sonderurlaubstage" />
                <b style={{ fontSize: SMALL_FONT_SIZE }}>
                  {special_vacation_days_count}
                </b>
              </td>
              <td
                style={{
                  fontSize: LARGE_FONT_SIZE,
                  paddingTop: "40px",
                  paddingBottom: "1.5em"
                }}
              >
                =
              </td>
              <td
                style={{
                  border: "1px solid black",
                  borderRadius: "5px",
                  paddingBottom: "1.5em"
                }}
              >
                <Label label="Gen. Urlaubstage" />
                <b style={{ fontSize: MEDIUM_FONT_SIZE }}>
                  {used_vacation_days}
                </b>
              </td>
              <td
                style={{
                  border: "1px solid black",
                  borderRadius: "5px",
                  paddingBottom: "1.5em"
                }}
              >
                  <Label label="Krankheitstage" />
                  <b style={{ fontSize: MEDIUM_FONT_SIZE }}>
                      {sickness_days_count}
                  </b>
              </td>
            <td
                style={{
                  border: "1px solid black",
                  borderRadius: "5px",
                  paddingBottom: "1.5em"
                }}
              >
                  <Label label="Home Office" />
                  <b style={{ fontSize: MEDIUM_FONT_SIZE }}>
                      {homeOfficeDays}
                  </b>
              </td>
            </tr>
          </tbody>
        </table>

        <table style={{ marginBottom: "3em", width: "100%" }}>
          <tbody>
            <tr>
              {(+paid_extra_time_duration > 0) && (
                <td style={{}}>
                  <Label label="Ausbez. Überstunden" />
                  <b style={{ fontSize: SMALL_FONT_SIZE }}>
                    {paid_extra_time_duration.format("h[h ]m[m]")}
                  </b>
                </td>
              )}
              <td 
                style={{
                  border: "1px solid black",
                  borderRadius: "5px",
                  paddingBottom: "1.5em"
                }}
              >
                <Label label="Ist-Arbeitszeit" />
                <b style={{ fontSize: SMALL_FONT_SIZE }}>
                  {work_time_duration.format("h[h ]m[m]")}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default ReportResult



// WEBPACK FOOTER //
// ./src/components/ReportResult.jsx